// Lib
import * as React from "react";
// Components
import { Spinner } from "@fluentui/react-components";
// Utilities
import { customizeStyles } from "../utilities/StyleUtilities";
import { useStyles } from "./SuspenseSpinner.styles";
/**
 * Suspense spinner while loading lazy loaded panel components
 */ export const SuspenseSpinner = (props)=>{
    const { customStyles } = props;
    const classNames = customizeStyles(useStyles(), customStyles);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames.containerStyle
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames.centerContentStyle
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames.spinnerWrapperStyle
    }, /*#__PURE__*/ React.createElement(Spinner, {
        size: "large"
    }))));
};
